// extracted by mini-css-extract-plugin
export default {"menu":"menu--JIS4Q","seperator":"seperator--es80u","icon":"icon--UZm_K","option":"option--R80Ii","danger":"danger--aruld","trigger":"trigger--EcL3e","open":"open--fjAWE"};